export enum ModulesStatusEnum {
  EVENT_MODULES = 'event-modules/get/constructor',
  EVENT_MODULE = 'event-module/get',
}



// WEBPACK FOOTER //
// ./src/services/api/event-modules/types.ts